import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { TopBar } from "@/components/layout/TopBar";
import { BottomNav } from "@/components/layout/BottomNav";
import { SandboxBanner } from "@/components/layout/SandboxBanner";
import { DemoTour } from "@/components/common/DemoTour";

export default function AppShell() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="flex min-h-screen bg-background" data-testid="app-shell">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <SandboxBanner />
        <DemoTour />
        <TopBar />
        <main key={pathname} className="mx-auto w-full max-w-6xl flex-1 px-4 pb-32 pt-6 sm:px-6 md:pb-12 lg:px-10 lg:pt-10">
          <Outlet />
        </main>
      </div>
      <BottomNav />
    </div>
  );
}
